export default "__VITE_ASSET__5be1e823__"